import { jsx as _jsx } from "react/jsx-runtime";
import { useSlippageStore } from '../../../../../stores/slippageStore';
import { SlippageView } from './SlippageView';
export function Slippage(props) {
    const { slippage, setSlippage, autoSlippage, setAutoSlippage } = useSlippageStore();
    return (_jsx(SlippageView, { ...props, slippage: slippage, setSlippage: setSlippage, autoSlippage: autoSlippage, setAutoSlippage: setAutoSlippage }));
}
